module.exports = __webpack_public_path__ + "img/w_mockup_400.b29e896b.png";